/**
 * @class OptionSelectableBoxes
 * @classdesc Represents an option as selectable boxes
 *
 * @extends Core.Component
 */
export default class OptionSelectableBoxes extends Core.Component {
  /**
   * Returns the selected value or false if unselected
   */
  get selectedValue() {
    const inputs = [...this.queryAll('input-swatch'), ...this.queryAll('input-radio')];
    const checkedInput = inputs.find(input => input.checked);

    if (checkedInput) {
      return checkedInput.value;
    }

    return false;
  }

  set selectedValue(value) {
    const inputs = [...this.queryAll('input-swatch'), ...this.queryAll('input-radio')];
    const selectedInput = inputs.find(input => input.value === value);

    inputs.forEach(input => {
      if (input === selectedInput) {
        input.checked = true;
      } else {
        input.checked = false;
      }
    });
  }

  get position() {
    return this.data.position;
  }

  onMount() {
    this.events.register(this.el, 'change', () => {
      const inputFieldset = this.query('input-fieldset');
      const { selectedValue } = this;
      const div = document.createElement('div');

      div.innerHTML = this.data.chosen_option.replace('|value|', `<span>${selectedValue}</span>`);

      if (inputFieldset) {
        if (selectedValue) {
          inputFieldset.label = div.innerHTML;
        } else {
          inputFieldset.label = this.data.chose_option;
        }
      }
    });
  }

  setUnavailableValues(values) {
    const inputFieldset = this.query('input-fieldset');

    if (inputFieldset) {
      inputFieldset.setUnavailableValues(values);
    }
  }

  disableValues(values) {
    const inputFieldset = this.query('input-fieldset');

    if (inputFieldset) {
      inputFieldset.disableValues(values);
    }
  }

  removeValues(values) {
    const inputFieldset = this.query('input-fieldset');

    if (inputFieldset) {
      inputFieldset.removeValues(values);
    }
  }
}
